import { useContext } from 'react';

import { VisitGuidesContext } from '../../contexts/visit-guides';

export const useVisitGuides = () => {
  const context = useContext(VisitGuidesContext);

  return {
    getGuide: context.getGuide,
    variables: context.variables
  };
};
